import { FC, useRef} from "react"
import { AgGridColumn, AgGridReact } from "ag-grid-react"
import '../../../ag-grid.css'
import '../../../ag-theme-alpine.css'
import moment from "moment"
import { Chip } from 'primereact/chip';
import { useHistory } from "react-router-dom"


export const LaunchesTable:FC<any> = (props) => {

    const gridRef :any= useRef();

    const {data} = props

    let history:any = useHistory()

    const handleViewError = (e:any,params:any) => {
        history.push("errors",{
            visible: true,
            id: params.data.idtipoerror
        })
        
    }

    const statusRenderer = (params:any) => {
        const status:string = params.value
        switch(status) {
            case 'SCHEDULED':
                return(
                    <Chip className="chip-status" style={{backgroundColor: 'var(--info)',color: 'white'}} label="Programado" />
                )
            case 'RUNNING':
                return(
                    <Chip className="chip-status" style={{backgroundColor: 'var(--warning)',color: 'white'}} label="En ejecución" />
                )
            case 'ERROR':
                return(
                    <Chip className="chip-status" style={{backgroundColor: 'var(--error)',color: 'white',cursor:'pointer'}} onClick={(e:any) => handleViewError(e,params)} label="Error" />
                )
            case 'FINISHED':
                return(
                    <Chip className="chip-status" style={{backgroundColor: 'var(--success)',color: 'white'}} label="Finalizado" />
                )
            default:

        }
        return params.value
    }

    const parseDateRenderer = (params:any) => {
        return (moment(params.value).format('DD-MM-YYYY HH:mm:ss')) 
    }


    const handleCellStyle = () => {
        return {backgroundColor: 'transparent',color: 'black',fontWeight:'normal',borderRight:'1px solid #dee2e6',fontFamily:'var(--roboto-medium)',height:'100%'}   
    }


    return (
        <div className="ag-theme-alpine" style={{display:'flex',flexDirection:'column', height:'90%', width: '95%' }}>

            <AgGridReact
                ref={gridRef}
                headerHeight={30}
                getRowHeight={() => 30}
                rowData={data}
                enableCellTextSelection>
                <AgGridColumn cellStyle={handleCellStyle} filter    suppressNavigable={true} sortable  flex={1} hide headerName={"Lanzamiento ID"} field={"simulacion"}></AgGridColumn>
                <AgGridColumn cellStyle={handleCellStyle} filter    suppressNavigable={true} sortable  flex={1} hide  field={"idtipoerror"}></AgGridColumn>
                <AgGridColumn cellStyle={handleCellStyle} headerClass={"header-resize"} sortable filter  suppressNavigable={true}   flex={0.35} headerName={"Planta"} field={"planta"}></AgGridColumn>
                <AgGridColumn cellStyle={handleCellStyle} headerClass={"header-resize"} filter   suppressNavigable={true}   flex={0.25} hide headerName={"ID"} field={"id_escenario"}></AgGridColumn>
                <AgGridColumn cellStyle={handleCellStyle} headerClass={"header-resize"} sortable  filter suppressNavigable={true}  flex={0.5} headerName={"Escenario"} field={"escenario"}></AgGridColumn>
                <AgGridColumn  cellStyle={handleCellStyle} headerClass={"header-resize"} filter sort={'desc'} suppressNavigable={true} sortable  cellRenderer={parseDateRenderer} flex={0.5} headerName={"Fecha"} field={"fecha_creacion"}></AgGridColumn>
                <AgGridColumn cellStyle={handleCellStyle} headerClass={"header-resize"} sortable   suppressNavigable={true} cellRenderer={statusRenderer}   flex={0.35} headerName={"Estado"} field={"status"}></AgGridColumn>
                <AgGridColumn  cellStyle={handleCellStyle} headerClass={"header-resize"} filter  suppressNavigable={true} sortable  flex={1.5} headerName={"Log"} tooltipField="descripcion"  field={"descripcion"}></AgGridColumn>
                
            </AgGridReact>
        </div>
    )
}